import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid, IconButton,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Theme
} from "@mui/material";
import {formatDate, formatPeso, translateText} from "../../helpers";
import Strings from "../../assets/strings";
import {FileOpenOutlined, FilterList} from "@mui/icons-material";
import React, {useCallback, useEffect, useState} from "react";
import {getCajasMovimientos} from "../../services";
import {ButtonResponsive, HtmlTooltip, ListViewMode, Pagination} from "../../components";
import {ICajaCierreFilter, ICajaMovimiento, ICajaMovimientoRes} from "../../redux/types/ICaja";
import makeStyles from "@mui/styles/makeStyles";
import {TIPO_MOVIMIENTO} from "../../helpers/CONSTANTES";
import {useLocation, useNavigate} from "react-router-dom";
import ReciboPago from "../../components/recibo";
import DetallesGasto from "../gastos/detallesGasto";
import TopBarDialog from "../../components/topBar/TopBarDialog";
import DetallesIngreso from "../ingresos/detallesIngreso";

const useStyles = makeStyles((theme:Theme) => ({
    content: {
        padding: "0 !important",
    },
    tHead:{
        background:"rgb(237, 247, 237)"
    }
}));

const initialFilter:ICajaCierreFilter = {fechaDesde:"",fechaHasta:""} //,cmoTipo:"",cciId:""
export default function CajaMovimientos({cajId, defaultMovimientos, cierreId}:{cajId:number, defaultMovimientos?:ICajaMovimientoRes, cierreId?:number}){
    const classes = useStyles();
    let navigate = useNavigate();
    let { pathname} = useLocation();
    const [showAnulado, setShowAnulado] = useState(false);

    const [loading,setLoading] = useState(false);
    const [openFilter, setOpenFilter] = useState(false)
    const [filter, setFilter] = useState(initialFilter);

    const [list, setList] = useState<ICajaMovimientoRes>()

    const filterMov = useCallback((obj:any)  => {
        setLoading(true);
        setOpenFilter(false);

        getCajasMovimientos(cajId,obj).then(res=>{
            setList(res.data)
            // setActiveTab(0);
            //   setMovFiltered(res.data)
        }).finally(()=>setLoading(false))
    }, [setLoading, setOpenFilter, setList, cajId])


    useEffect(() => {
        setList(defaultMovimientos)
    }, [setList, defaultMovimientos]);

    useEffect(() => {
        setFilter(prevState => ({...prevState, cierreId}))
        if(cierreId){
            filterMov({...initialFilter, cierreId})
        }
    }, [filterMov, cierreId, setFilter]);


    const onVewDoc = (mov:ICajaMovimiento) => {

        switch (mov.tipo) {
            case TIPO_MOVIMIENTO.PRESTAMO:
            case TIPO_MOVIMIENTO.REENGANCHE_PRESTAMO:
            case TIPO_MOVIMIENTO.GASTOS_LEGALES:
            case TIPO_MOVIMIENTO.CANCELACION_PRESTAMO:
                navigate("/prestamo/"+mov.documentoId)
                break
            case TIPO_MOVIMIENTO.PAGO:
            case TIPO_MOVIMIENTO.ANULACION_PAGO:
                navigate(pathname,{state:{recibo: {id:mov.documentoId}}})
                break
            case TIPO_MOVIMIENTO.GASTO:
            case TIPO_MOVIMIENTO.ANULACION_GASTO:
                navigate(pathname,{state:{detalleGasto: {id:mov.documentoId}}})
                break
            case TIPO_MOVIMIENTO.INGRESO:
                navigate(pathname,{state:{detalleIngreso: {id:mov.documentoId}}})
                break
        }
    }

    const handleFilter = (e:React.ChangeEvent<HTMLInputElement>)=>{
        const {name, value} = e.target;

        setFilter({...filter,[name]:value});
        if(name === "name" || name === "page" || name === "pageSize") return  filterMov({...filter,page:1,[name]:value});
    };

    let resetFilter = ()=>{
        setFilter(initialFilter);
        filterMov(filter)
    }
    return <>

        <Dialog open={openFilter} onClose={()=>setOpenFilter(false)} maxWidth={"xs"} >
            <TopBarDialog title={Strings.filtrar} onClose={()=>setOpenFilter(false)} light/>

            <DialogContent>
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <TextField
                            label={Strings.fechaDesde}
                            type="date"
                            value={filter.fechaDesde}
                            fullWidth
                            InputLabelProps={{shrink: true}}
                            onChange={({target})=>setFilter({...filter,fechaDesde:target.value})}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            label={Strings.fechaHasta}
                            type="date"
                            value={filter.fechaHasta}
                            fullWidth
                            InputLabelProps={{shrink: true}}
                            onChange={({target})=>setFilter({...filter, fechaHasta:target.value})}
                        />
                    </Grid>
                    {/*{activeTab === 0 &&*/}
                    {/*<Grid item xs={12}>*/}
                    {/*    <SelectEnum value={filter.cmoTipo}*/}
                    {/*                group={"tiposCajasMovimiento"}*/}
                    {/*                label={Strings.tipo}*/}
                    {/*                all*/}
                    {/*                onChange={({target}:any)=>setFilter({...filter, cmoTipo:target.value})}*/}
                    {/*    />*/}
                    {/*</Grid>*/}
                    {/*}*/}

                </Grid>
                <br/>
            </DialogContent>
            <DialogActions>
                <Button onClick={resetFilter} color={"warning"} size={"small"} sx={{textTransform:"capitalize"}}>
                    {Strings.restablecer}
                </Button>
                <Button color="primary" onClick={()=>filterMov(filter)} variant={"outlined"}>
                    {Strings.filtrar}
                </Button>
            </DialogActions>
        </Dialog>

        {!cierreId &&
            <ListViewMode pageRows={list?.pageSize} pageTotalRows={list?.totalCount}>
                <ButtonResponsive icon={<FilterList/>} text={Strings.filtrar} onClick={() => setOpenFilter(true)}/>
            </ListViewMode>
        }
        <TableContainer>
            <Table sx={{minWidth: 743}} size={"small"} aria-label="simple table">
                <TableHead
                    className={!!cierreId ? classes.tHead : ""}
                >
                    <TableRow>
                        <TableCell/>
                        <TableCell>{Strings.tipo} {Strings.movimientos}</TableCell>
                        <TableCell>{Strings.fecha}</TableCell>
                        <TableCell>{Strings.monto}</TableCell>
                        <TableCell className="comment">{Strings.comentario}</TableCell>
                        <TableCell>{Strings.creadoPor}</TableCell>
                        <TableCell sx={{maxWidth:100,textAlign:"right"}}>
                            <FormControlLabel className="d-print-none" sx={{margin: 0}}
                                              control={
                                                  <Switch
                                                      size={"small"}
                                                      checked={showAnulado}
                                                      onChange={()=>setShowAnulado(!showAnulado)}
                                                      value="checkedB"
                                                  />
                                              }
                                              label={Strings.anulado}
                            />
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {list?.items?.filter(item=>!item.fechaAnulacion || showAnulado )?.map((row,i) =>
                        <TableRow key={row.id} className={row.fechaAnulacion ? "text-red-deep" : ""}>
                            <TableCell className="actionCell" width={20}>
                                {([
                                        TIPO_MOVIMIENTO.PRESTAMO,
                                        TIPO_MOVIMIENTO.CANCELACION_PRESTAMO,
                                        TIPO_MOVIMIENTO.REENGANCHE_PRESTAMO,
                                        TIPO_MOVIMIENTO.GASTOS_LEGALES,
                                        TIPO_MOVIMIENTO.PAGO,
                                        TIPO_MOVIMIENTO.ANULACION_PAGO,
                                        TIPO_MOVIMIENTO.GASTO,
                                        TIPO_MOVIMIENTO.INGRESO,
                                        TIPO_MOVIMIENTO.ANULACION_GASTO
                                    ].includes(row.tipo!)) &&
                                    <HtmlTooltip title={Strings.ver+" "+Strings.documento}>
                                        <IconButton
                                            onClick={()=>onVewDoc(row)}
                                            size="large">
                                            <FileOpenOutlined className={"text-violet"}/>
                                        </IconButton>
                                    </HtmlTooltip>
                                }
                            </TableCell>
                            <TableCell>{translateText(row.tipoString)}</TableCell>
                            <TableCell>{formatDate(row.fechaCreacion)}</TableCell>
                            <TableCell>{formatPeso(row.monto)}</TableCell>
                            <TableCell className="comment">{row.concepto}</TableCell>
                            <TableCell  colSpan={!row.fechaAnulacion ? 2 : 1}>{row.usuarioCreadoPor}</TableCell>

                            {row.fechaAnulacion && <TableCell className={"alignRight"}> {formatDate(row.fechaAnulacion)}</TableCell>}

                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
        {list &&
            <Pagination
                empty={Boolean(!list.items?.length && loading)}
                count={list.totalCount || 0}
                rowsPerPage={filter.pageSize??15}
                page={list.pageNumber - 1}
                onPageChange={(e, page) => {
                    filterMov({...filter,page:page + 1})
                }}
                onRowsPerPageChange={handleFilter}
            />
        }

        <ReciboPago toPreIcon/>
        <DetallesGasto />
        <DetallesIngreso />
    </>
}
